import { Benefit } from "../models/Benefit";
import BenefitComponent from "./Benefit";

import Benefit1Img from "../assets/images/benefit-1.png";
import Benefit2Img from "../assets/images/benefit-2.png";
import Benefit3Img from "../assets/images/benefit-3.png";
import Benefit4Img from "../assets/images/benefit-4.png";

const Why = () => {
  const gagalinFont = {
    fontFamily: "Gagalin",
  };

  const caveatFont = {
    fontFamily: "Caveat",
  };

  const benefits: Benefit[] = [
    {
      id: 1,
      icon: Benefit1Img,
      header: "Bisa Request Desain",
      description:
        "kamu bisa menggunakan gambar pilihanmu sendiri. bisa tambah nama juga",
    },
    {
      id: 2,
      icon: Benefit2Img,
      header: "Garansi Ganti Baru",
      description:
        "jika produk rusak/tidak sesuai, bisa langsung ganti baru tanpa biaya tambahan.",
    },
    {
      id: 3,
      icon: Benefit3Img,
      header: "Pembayaran bisa COD",
      description:
        "kamu bisa melakukan pembayaran saat barang sampai di tempat kamu.",
    },
    {
      id: 4,
      icon: Benefit4Img,
      header: "Teknologi UV Jepang",
      description: "bahan case 100% premium, anti noda-anti air-anti api.",
    },
  ];

  return (
    <section className="pt-16 pb-8 px-6 primary-bg">
      <div className="text-center mb-8">
        <h1 className="text-6xl" style={gagalinFont}>
          KENAPA?
        </h1>

        <h2 className="text-3xl font-bold" style={caveatFont}>
          Kenapa harus beli disini ?
        </h2>
      </div>

      {benefits.map((benefit) => (
        <BenefitComponent key={benefit.id} benefit={benefit}></BenefitComponent>
      ))}

      <div className="w-11/12 mt-12 border-b border-gray-400"></div>
    </section>
  );
};

export default Why;
